
import virtualServerPageData from "../../data/virtual-server";

export default {
  data() {
    return {
      items: virtualServerPageData.usesg,
      uses: virtualServerPageData.usesg,
    };
  },
};
